import { displayToast, sendAppsignalError } from "../modules/utils";

class IncomeFilter {
  constructor(node) {
    this.element = node;
    this.datepickerInput = this.element.querySelector(".js-income-filter-datepicker");
    this.contentWrapper = this.element.querySelector(".js-bonus-wrapper");

    this.endpointUrl = new URL(this.element.dataset.endpointUrl, window.location);

    this.initialize();
  }

  initialize() {
    this.datepickerInput.addEventListener("datepicker-change", (e) => {
      const { name, value } = e.target;

      this.endpointUrl.searchParams.set(name, value);
      this.handleFilterChange();
    });
  }

  handleFilterChange() {
    this.contentWrapper.querySelectorAll(".content-wrapper").forEach((element) => {
      element.classList.add("is-loading");
    });

    fetch(this.endpointUrl)
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { html } = data;

        this.contentWrapper.innerHTML = html;
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "IncomeFilter", {
          response: this.response,
        });
      });
  }
}

const incomeFilterElement = document.querySelector('[data-js="income-filter"]');

if (incomeFilterElement) {
  new IncomeFilter(incomeFilterElement);
}
